export const SCREEN_CONNECTED_ACTION = "screenConnected"
export const getScreensChannelName = eventId =>
  `digital-signage-${eventId}-screens`
export const getManagerChannelName = eventId =>
  `digital-signage-${eventId}-manager`



// WEBPACK FOOTER //
// ./src/types/pubnub.js